import RightButtons from "./RightButtons";
export default RightButtons;